import Vue from 'vue'
import Router from 'vue-router'
import pocetna from '@/components/pocetna'
import about from '@/components/about'
import proizvodi from '@/components/proizvodi'
// import singlpro from '@/components/singlpro'
import admin from '@/components/admin'
import saveti from '@/components/saveti'
import basket from '@/components/basket'
import contact from '@/components/contact'
import pojedinacna from '@/components/pojedinacna'
import podkategorije from '@/components/podkategorije'
import test from '@/components/test'
// import slide from '@/components/slide'
import editor from '@/components/editor'
// import uslovi from '@/components/uslovi'
// import prava from '@/components/prava'

Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      component: pocetna
    },

    {
      path: '/o-nama',
      component: about
    },
    {
      path: '/saveti',
      component: saveti
    },
    {
      path: '/saveti/:vrsta',
      component: saveti
    },
    {
      path: '/test',
      component: test
    },
    {
      path: '/test/:test',
      component: test
    },
    // {
    //   path: '/o nama',
    //   component: about
    // },
    {
      path: '/editor',
      component: editor
    },
    // {
    //   path: '/korpa',
    //   component: basket
    // },
    {
      path: '/kontakt',
      component: contact
    },
    // {
    //   path: '/kontakt',
    //   component: contact
    // },
    {
      path: '/admin',
      component: admin
    },
    {
      path: '/admin/:pozicija',
      component: admin
    },
    {
      path: '/admin/:pozicija/:katid',
      component: admin
    },
    // {
    //   path: '/proizvodnja',
    //   component: manufacturing
    // },
    // {
    //   path: '/products',
    //   component: products,
    // },
    {
      path: '/proizvodi',
      component: proizvodi,
    },
    {
      path: '/proizvodi/:kategorije',
      component: proizvodi,

    },

    {
      path: '/proizvodi/:kategorije/:podkategorije',
      component: proizvodi,
    },
    {
      path: '/korpa',
      component: basket,
    },

    // // {
    // // path: '/panel',
    // // component: panel
    // // },


  ],

  mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js